// extracted by mini-css-extract-plugin
module.exports = {"modal":"issues_modal_31xvJAz","buttonWrapper":"issues_buttonWrapper_1-sx_tR","button":"issues_button_1-aFczd"};